<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     开票历史
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-invoice mb-md">

    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <f-date-range-picker v-model="listQuery.applytime" :shortcuts="[0, -7, -30, -90]" @change="fetchData(1)" />
        </div>
        <div class="filter-item" style="width: 120px;">
          <el-select v-model="listQuery.invoice_status" placeholder="发票状态" clearable @change="fetchData(1)">
            <el-option
              v-for="(item, index) in $store.state.expenseStore.orderInvoiceStatusArr"
              :key="index"
              :label="item.title"
              :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item" style="width: 240px">
          <el-input v-model="listQuery.keyword" placeholder="订单号 / 发票号" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
      <div class="toolbox">
        <el-button type="success" @click="$router.push('/expense/invoice/apply')">申请开票</el-button>
        <el-button type="success" plain @click="$router.push('/expense/invoice/info')">发票信息管理</el-button>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never">
      <el-table
        ref="listTable"
        :data="list"
        style="width: 100%">
        <el-table-column label="申请时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.applytime | parseTime('{y}/{m}/{d} {h}:{i}') }}
          </template>
        </el-table-column>
        <el-table-column label="发票抬头" :show-overflow-tooltip="true" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.corporate_name }}
          </template>
        </el-table-column>
        <el-table-column label="发票类型" min-width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.invoice_type == 2" type="info" effect="light">纸质普票</el-tag>
            <el-tag v-else-if="scope.row.invoice_type == 3" type="blue" effect="light">纸质专票</el-tag>
            <el-tag v-else-if="scope.row.invoice_type == 4" effect="light" type="warning">电子普票</el-tag>
            <el-tag v-else-if="scope.row.invoice_type == 5" effect="light" type="primary">电子专票</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发票总额" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.money | currency }}
          </template>
        </el-table-column>
        <el-table-column label="发票状态" min-width="120" align="center">
          <template slot-scope="scope">
            <span :class="{ 'text-danger': scope.row.invoice_status !== 2 }">{{ orderInvoiceStatusObj[scope.row.invoice_status] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发票序列号" :show-overflow-tooltip="true" min-width="160">
          <template slot-scope="scope">
            <el-link v-if="scope.row.invoice_type == 4 || scope.row.invoice_type == 5" :underline="false" @click="openPdfpreview(scope.row.attach_url)" class="mr-xs">{{ scope.row.invoice_sn }}</el-link>
            <span v-else>{{ scope.row.invoice_sn }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="$router.push('/expense/invoice/detail?oinvoiceid=' + scope.row.oinvoiceid)">查看</el-button>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="listQuery.pindex" :psize.sync="listQuery.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>
    <pdf-preview v-if="activePdf" :show.sync="activePdf" :src="pdfSrc"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getOrderInvoiceListApi } from '@/api/expense/expenseOinvoiceApi'
import PdfPreview from './components/PdfPreview.vue'
export default {
  name: 'ExpenseInvoice',
  components: {
    PdfPreview,
  },
  data() {
    return {
      loading: false,
      listQuery: {
        applytime: null,
        invoice_status: null,
        keyword: '',
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      total: 0,
      list: [],
      activePdf:false,
      pdfSrc:''
    }
  },
  computed: {
    ...mapGetters([
      'orderInvoiceStatusObj',
      'shippingStatusObj'
    ])
  },
  created() {
    const keepAlivePath = [
      '/expense/invoice/detail'
    ]
    this.listQuery = this.$utils.initListQuery(this.listQuery, keepAlivePath)
    this.fetchData()
  },
  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.listQuery)
    next()
  },
  methods: {
    fetchData(page) {
      if (page) this.listQuery.pindex = page
      this.loading = true
      getOrderInvoiceListApi(this.listQuery).then(res => {
        this.loading = false
        if (!res.errno) {
          this.total = res.data.total
          this.list = res.data.list
        }
      })
    },
    openPdfpreview(src){
      this.pdfSrc = src;
      this.activePdf = true;
    },
  }
}
</script>
